export default __webpack_public_path__ + "static/media/arq-sistemas-avan.15d15a9d.png";